export default __webpack_public_path__ + "static/media/favicon.63987879.ico";